import React,{useState} from 'react';
import { Alert,Box,Button,IconButton,MenuItem,Paper,Stack,TextField,Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RafagaGrupoIcono,{iconosGrupo} from '../../../components/RafagaGrupoIcono';
import { claveGrupo } from '../../dashboard/GruposRafaga';
import { optimizarLogo } from '../../../utils/optimizarLogo';
export default function ConfiguradorGrupos({grupos,setGrupos,accesos,disabled,onError,onProcessing}) {
  const [procesando,setProcesando]=useState(false);
  const [resultado,setResultado]=useState('');
  const [errorImagen,setErrorImagen]=useState('');
  const bloqueado=disabled || procesando;
  const change=(index,field,value) => setGrupos((prev) => prev.map((g,i) => i===index ? {...g,[field]:value} : g));
  const image=async(index,file) => {
    if(!file) return;
    const clave=grupos[index].clave;
    setProcesando(true);setResultado('');setErrorImagen('');onProcessing?.(true);
    try {
      const logo=await optimizarLogo(file);
      setGrupos((prev) => prev.map((g) => g.clave===clave ? {...g,imagen:logo.imagen} : g));
      setResultado(`Logo preparado automáticamente: ${logo.ancho} × ${logo.alto} px, ${(logo.bytes/1024).toFixed(1)} KB. Guarda los grupos para aplicar el cambio.`);
    } catch(e) {const mensaje=e.message || 'No se pudo procesar la imagen.';setErrorImagen(mensaje);onError(mensaje);}
    finally {setProcesando(false);onProcessing?.(false);}
  };
  const remove=(g) => {
    if(accesos.some((a) => claveGrupo(a)===g.clave) || grupos.some((s) => s.padre===g.clave)) {
      onError('Mueve los servicios y subgrupos a otro grupo antes de eliminarlo.');return;
    }
    setGrupos((prev) => prev.filter((s) => s.clave!==g.clave));
  };
  return <Stack spacing={2}>
    <Typography variant="h6">Grupos e instituciones</Typography>
    <Typography color="text.secondary">Crea secciones como Free Fire y subgrupos como Trámites → SAT o RENAP. Los iconos son alusivos; para usar un logo institucional puedes subir su imagen.</Typography>
    <Typography variant="body2" color="text.secondary">Puedes subir imágenes PNG, JPG o WebP de hasta 10 MB. Se reducen automáticamente conservando la proporción y la transparencia.</Typography>
    {procesando && <Alert severity="info">Preparando logo…</Alert>}
    {errorImagen && <Alert severity="error">{errorImagen}</Alert>}
    {resultado && <Alert severity="success">{resultado}</Alert>}
    <Stack direction={{xs:'column',sm:'row'}} spacing={1}>
      <Button variant="outlined" disabled={bloqueado || grupos.length>=30} onClick={() => setGrupos((prev) => [...prev,{
        clave:window.crypto?.randomUUID?.() || `grupo-${Date.now()}-${Math.random().toString(36).slice(2)}`,
        nombre:'Nuevo grupo',padre:null,icono:'servicios',imagen:'',
      }])}>Añadir grupo / subgrupo</Button>
      <Button disabled={bloqueado || grupos.length>24} onClick={() => setGrupos((prev) => {
        const sugeridos=[{clave:'free-fire',nombre:'Free Fire',padre:null,icono:'juegos'},
          {clave:'tramites',nombre:'Trámites',padre:null,icono:'negocio'},
          {clave:'renap',nombre:'RENAP',padre:'tramites',icono:'identidad'},
          {clave:'sat',nombre:'SAT',padre:'tramites',icono:'impuestos'},
          {clave:'pnc',nombre:'PNC',padre:'tramites',icono:'seguridad'},
          {clave:'oj',nombre:'OJ',padre:'tramites',icono:'justicia'}];
        return [...prev,...sugeridos.filter((s) => !prev.some((g) => g.clave===s.clave))];
      })}>Añadir grupos sugeridos</Button>
    </Stack>
    {grupos.map((g,i) => <Paper variant="outlined" sx={{p:2,borderRadius:2}} key={g.clave}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center"><RafagaGrupoIcono grupo={g} /><Typography fontWeight={700}>{g.nombre}</Typography></Stack>
        <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(3,1fr)'},gap:2}}>
          <TextField label="Nombre del grupo" value={g.nombre} disabled={bloqueado} inputProps={{maxLength:120}} onChange={(e) => change(i,'nombre',e.target.value)} />
          <TextField select label="Dentro de" value={g.padre || ''} disabled={bloqueado} onChange={(e) => {
            if(e.target.value && grupos.some((s) => s.padre===g.clave)) {onError('Este grupo tiene subgrupos. Muévelos primero para poder convertirlo en subgrupo.');return;}
            change(i,'padre',e.target.value || null);
          }}>
            <MenuItem value="">Grupo principal</MenuItem>
            {grupos.filter((s) => !s.padre && s.clave!==g.clave).map((s) => <MenuItem key={s.clave} value={s.clave}>{s.nombre}</MenuItem>)}
          </TextField>
          <TextField select label="Icono alusivo" disabled={bloqueado} value={g.icono || 'servicios'} onChange={(e) => change(i,'icono',e.target.value)}>
            {Object.entries(iconosGrupo).map(([key,label]) => <MenuItem key={key} value={key}>{label}</MenuItem>)}
          </TextField>
        </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
          <Button component="label" disabled={bloqueado}>Subir logo / imagen<input hidden disabled={bloqueado} type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => {image(i,e.target.files?.[0]);e.target.value='';}} /></Button>
          {g.imagen && <Button disabled={bloqueado} onClick={() => change(i,'imagen','')}>Quitar imagen</Button>}
          <Button disabled={bloqueado || i===0} onClick={() => setGrupos((prev) => {const next=[...prev];[next[i-1],next[i]]=[next[i],next[i-1]];return next;})}>Subir orden</Button>
          <IconButton disabled={bloqueado} aria-label={`Eliminar grupo ${g.nombre}`} onClick={() => remove(g)}><DeleteOutlineIcon /></IconButton>
        </Stack>
      </Stack>
    </Paper>)}
    <Typography variant="caption" color="text.secondary">Después asigna los servicios a su grupo y guarda la Zona de Ráfaga. Crear grupos no crea servicios ni cambia sus precios.</Typography>
  </Stack>;
}
